import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17 3v10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12.67 5.5 8.66 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12.67 10.5 8.66-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Regex";
const Regex = memo(themed(Icon));
export {
  Regex
};
//# sourceMappingURL=regex.js.map
